import { DEFAULT_EMPTY } from '@/utils/constant'

/**
 * 解析 extension 字段（JSON 字符串）为普通对象数组
 * @param {string|undefined|null} extensionStr - extension 字段的 JSON 字符串
 * @returns {Array} 解析后的审核历史数组，解析失败时返回空数组
 */
export function parseExtension(extensionStr) {
  // 防御性检查：参数不存在或非字符串
  if (!extensionStr || typeof extensionStr !== 'string') {
    return []
  }
  
  try {
    const parsed = JSON.parse(extensionStr)
    
    // 确保解析结果是数组
    if (!Array.isArray(parsed)) {
      return []
    }
    
    // 确保每个元素都是有效对象
    return parsed.filter(item => {
      return item && typeof item === 'object'
    }).map(item => ({
      createTime: item?.createTime || '',
      auditInfo: item?.auditInfo || '',
      auditInfoEnum: item?.auditInfoEnum || '',
      colour: item?.colour || '',
      type_name: item?.type_name || '',
      remark: item?.remark || ''
    }))
  } catch (error) {
    // JSON 解析失败
    console.error('解析 extension 失败:', error)
    return []
  }
}

/**
 * 处理车主认证审核进度卡片的数据
 * @param {Object} response - 接口返回的响应数据
 * @param {Vue} vm - Vue 组件实例，用于访问 DEFAULT_EMPTY
 * @returns {Array} 处理后的 infoArray 数组
 */
export function processApproveProgressData(response,vm) {
  const emptyValue = DEFAULT_EMPTY
  
  const mobile = response?.mobile
  const vin = response?.vin
  
  // 解析 extension 字段获取审核历史
  const extensionStr = response?.extension
  const extensionList = parseExtension(extensionStr)
  console.log('extensionList==>',extensionList)
  const infoArray = []
  
  // 手机号
  infoArray.push({
    label: '手机号',
    value: mobile || emptyValue,
    key: 'mobile'
  })
  
  // 车架号后六位（考虑为空的情况）
  let vinValue = emptyValue
  if (vin && vin !== emptyValue) {
    vinValue = vin.slice(-6)
  }
  infoArray.push({
    label: '车架号后六位',
    value: vinValue,
    key: 'vin'
  })
  vm.infoArray = infoArray
  vm.resultTemplates = generateResultTemplates(extensionList)
}

/**
 * 根据 extensionList 生成 resultTemplates 数组
 * @param {Array} extensionList - 解析后的审核历史数组
 * @returns {Array} resultTemplates 数组
 */
export function generateResultTemplates(extensionList) {
  if (!Array.isArray(extensionList) || extensionList.length === 0) {
    return []
  }
  
  // 遍历 extensionList 中的每一项，生成 resultTemplates 数组
  return extensionList.map(record => ({
    resultArray: [
      {
        label: '认证类型',
        value: record?.type_name || '',
      },
      {
        label: '审核状态',
        value: record?.auditInfo || '',
        render: function() {
          const color = '#1A1D25'
          return `<span style="font-weight: bold; color: ${color};">${this.value}</span>`
        }
      }
    ],
    colour: record?.colour || '',
    remark: record?.remark || ''
  }))
}
